import { Injectable } from '@angular/core';
import {ValidationConfig} from './validation.config';

import { get } from 'lodash-es';

@Injectable()
export class ValidationService {

  constructor() {
    //This is intentional
  }

  /**
   * Getting the relevant error message by the field ID
   * **/
  getErrorMessage(fieldId) {
    return get(ValidationConfig, `errorMessages[${fieldId}].message`, '');
  }
}
